import { render, staticRenderFns } from "./FormValoracion.vue?vue&type=template&id=7752bae6"
import script from "./FormValoracion.vue?vue&type=script&lang=js"
export * from "./FormValoracion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports